export default `
.viewer {
    margin-left: -20px;
}

.viewer__node--depth-0 {
    font: 18px Arial;
}

.viewer__node--depth-1 {
    font:16px Arial;
}

.viewer__node--depth-2 {
    font: 14px  Arial
}

.viewer__node--depth-3 {
    font: 12px Arial;
}
`;



// WEBPACK FOOTER //
// ./src/code-examples/viewer-css.js